/**
 * KAN-873: какие пометки показать в строке настройки на текущей вкладке /m.
 * Данные из тех же хуков, что у экрана "Начало работы" и профиля; правила в
 * lib/managerSetupChips.ts и lib/managerSetupPending.ts.
 */
import { useLocation } from 'react-router-dom';
import { useMissingManagerPhone } from '@/hooks/useManagerProfile';
import { usePushSubscription } from '@/hooks/usePushSubscription';
import { getSetupChips, type SetupChipId } from '@/lib/managerSetupChips';
import { getSetupPending, type SetupPending } from '@/lib/managerSetupPending';

export function useSetupChips(): SetupChipId[] {
  const push = usePushSubscription();
  const missingPhone = useMissingManagerPhone();
  const { pathname } = useLocation();
  const { data, hasManager } = push.status;

  // Пока push грузится или статуса нет (запрос упал, нет ключа VAPID), пометок
  // уведомлений и Telegram нет; телефон от этого не зависит.
  const pending: SetupPending | null =
    hasManager && push.view !== 'loading' && data
      ? getSetupPending({
          pushView: push.view,
          telegram: { linked: data.telegram_linked, botConnected: data.bot_connected },
        })
      : null;

  return getSetupChips({ pending, missingPhone, pathname });
}
